var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiversx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0861 23L42.3493 13.8911L39.4721 8.39682L23.6475 14.7586C23.2159 14.9032 22.7843 14.9032 22.3527 14.7586L6.52808 8.39682L3.65088 13.8911L20.9141 23L3.65088 32.1089L6.52808 37.6032L22.3527 31.2414C22.7843 31.0968 23.2159 31.0968 23.6475 31.2414L39.4721 37.6032L42.3493 32.1089L25.0861 23Z",
    fill: "#23F7DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiversx);
export default __webpack_public_path__ + "static/media/multiversx.86ae9ac9c035268913ff3def04247c7e.svg";
export { ForwardRef as ReactComponent };